module.exports = __webpack_public_path__ + "media/images/sp/specials/common/event_detail_new_product-feaed8827b8c54e3730aebf19357a3e9.jpg";